(function ($, window, document) {
    'use strict';

    window.AdminKit = window.AdminKit || {};

    window.initSelect2 = function (scope) {
        var $scope = scope ? $(scope) : $(document);

        $scope.find('.select2').each(function () {
            var $select = $(this);

            if ($select.hasClass('select2-hidden-accessible')) {
                return;
            }

            $select.select2({
                width: '100%',
                dropdownParent: $select.closest('.admin-modal').length ? $select.closest('.admin-modal') : $(document.body)
            });
        });
    };

    function toggleProjectsField($select) {
        var $form = $select.closest('form');
        var $field = $form.find('.projects-field');
        var requiresProjects = ['qaqc_head', 'chief_supervisor', 'housekeeper'].indexOf($select.val()) !== -1;

        $field.toggleClass('is-visible', requiresProjects);

        if (!requiresProjects) {
            $field.find('select').val(null).trigger('change');
        }
    }

    function toggleChiefSupervisorField($select) {
        var $form = $select.closest('form');
        var $field = $form.find('.chief-supervisor-field');
        var requiresChiefSupervisor = $select.val() === 'supervisor';

        $field.toggleClass('is-visible', requiresChiefSupervisor);

        if (!requiresChiefSupervisor) {
            $field.find('select').val(null).trigger('change');
        }
    }

    function togglePasswordFields($select) {
        var $form = $select.closest('form');
        var $fields = $form.find('.password-field-wrapper');
        var isHousekeeper = $select.val() === 'housekeeper';

        $fields.toggle(!isHousekeeper);

        if (isHousekeeper) {
            $fields.find('input').val('').removeClass('is-invalid');
            $fields.find('.error-message').text('').hide();
        }
    }

    window.AdminKit.select2 = {
        init: function () {
            window.initSelect2(document);

            $('[name="user_type"]').each(function () {
                toggleProjectsField($(this));
                toggleChiefSupervisorField($(this));
                togglePasswordFields($(this));
            });
        }
    };

    $(document).on('change', '[name="user_type"]', function () {
        toggleProjectsField($(this));
        toggleChiefSupervisorField($(this));
        togglePasswordFields($(this));
    });
})(jQuery, window, document);
